export default "<app-navbar></app-navbar>\n<router-outlet></router-outlet>\n<app-footer *ngIf=\"router.url == '/welcome'\"></app-footer>\n";